import React, { useState } from 'react';
import { Layout } from '../../contexts/LayoutContext';
import Header from './components/Header';
import Form from './components/Form';
import FormDialog from './components/FormDialog';
import AuthService from '../../services/auth/AuthService';
import ExpiredModal from './components/ExpiredModal';

const Login = () => {
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(AuthService.getExpiredTimeModal());
  const handleCloseModal = () => {
    AuthService.unsetExpiredTimeModal();
    setShowModal(false);
  };
  return (
    <Layout accessOnTrialEnds title="Login">
      <FormDialog open={open} setOpen={setOpen} />
      <Header />
      <Form setOpen={setOpen} />
      <ExpiredModal
        open={showModal}
        handleClose={() => handleCloseModal()}
      />
    </Layout>
  );
};

export default Login;
